import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';

export class InformerExportComplete extends BaseNotification {
  constructor(data) {
    super(data);
  }
  getTheme() {
    return BaseNotification.THEME_ALERT;
  }
  getText() {
    const props = this.getI18nProps();
    const link_href = '/notifications';
    const link_tag = `<a href="${link_href}">${props.text_link}</a>`;

    return `${props.text_body} ${link_tag}`;
  }

  getI18nProps() {    
    const path = this.params.path || false;
    const file_id = this.params.file_id;

    return {
      path,
      file_id,
      text_body: i18n.t('notify.notification.export_complete.body'),
      text_link: i18n.t('notify.notification.export_complete.link')
    };
  }
}
